module.exports = __webpack_public_path__ + "img/product1.34bfe798.png";